module.exports = __webpack_public_path__ + "img/header@2x.515b7e7.webp";